import { BottomSection, CardComponent, CardRow, ContentWrapper, Docker, Table, Textbox } from 'components/generic';
import { editDockerlist } from 'config';
import { AnimatePresence, motion } from 'framer-motion';
import { useFetch } from 'hooks';
import { useEffect, useState, useMemo } from 'react';
import './style.scss';
import { textFormatter } from 'utils';
import { cloneDeep } from 'lodash';

const SlabMaintenance = () => {
	const [slabData, setSlabData] = useState();
	const [selectedCard, setSelectedCard] = useState();
	const [dockerState, setDockerState] = useState();
	const api = useFetch();

	useEffect(() => {
		slabListAPI();
	}, []);

	const reset = obj => {
		setSelectedCard(null);
		setDockerState(null);
	};

	const handleCheckbox = (e, el) => {
		setSelectedCard(e ? el?.el : false);
	};

	const handleCardToggler = async (e, c_id) => {
		const data = { c_isActive: e ? 'Y' : 'N', c_id };
		await api({ url: 'client/v1/clientStatusUpdate', method: 'post', data, successToaster: true });
		await slabListAPI();
		reset();
	};

	// listing cards
	const cardsDisplay = useMemo(() => {
		return (
			<CardRow>
				{slabData?.map((el, i) => (
					<CardComponent
						key={i}
						toggle
						toggleOn={el?.el?.c_isActive === 'Y'}
						handleToggle={e => handleCardToggler(e, el?.el?.c_id)}
						item={el}
						checkbox
						checked={selectedCard?.c_id === el?.el?.c_id}
						handleChecked={e => handleCheckbox(e, el)}
					/>
				))}
			</CardRow>
		);
	}, [slabData, selectedCard]);

	const handleDocker = async e => {
		e?.key === 'cancel' && reset();
		['edit', 'view'].includes(e?.key) && setDockerState(e?.key);
	};

	const dockerContainer = useMemo(
		() => (
			<AnimatePresence>
				{selectedCard && (
					<motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }} transition={{ duration: 0.1 }}>
						<Docker dockerClick={handleDocker} dockerlist={editDockerlist} selectlist={[selectedCard]} />
					</motion.div>
				)}
			</AnimatePresence>
		),
		[selectedCard]
	);

	const slabListAPI = async () => {
		const { data } = await api({ url: 'client/v1/listSubscriptionDetails', method: 'get' });
		setSlabData(data?.data?.map(el => ({ el, title: el?.c_name, updatedAt: el?.createdAt, description: el?.c_currencyCode })));
	};

	const slabSaveAPI = async () => {
		await api({ url: 'client/v1/editSubscriptionDetails', method: 'post', data: selectedCard, successToaster: true });
		await slabListAPI();
		reset();
	};

	const setSavePopupState = e => {
		e === 'Goback' && reset();
		e === 'Save' && slabSaveAPI();
	};

	const handleAmount = (e, i) => {
		setSelectedCard(prevState => {
			const state = cloneDeep(prevState);
			state['c_subscriptionAmount'][i].amount = parseInt(e?.target?.value) || 0;
			return state;
		});
	};

	const handleAmountBlur = (e, i) => {
		setSelectedCard(prevState => {
			const state = cloneDeep(prevState);
			const number = +e?.target?.value;
			state['c_subscriptionAmount'][i].amount = number?.toFixed(2);
			return state;
		});
	};

	return (
		<>
			{dockerState ? (
				<>
					<ContentWrapper>
						<h3>Client: {selectedCard?.c_name}</h3>
						<ul className='slab-list'>
							<li className='display-flex align-center flex-start slab-list__header'>
								<div style={{ flex: '0 0 50%' }}>Features Utilised</div>
								<div style={{ flex: '0 0 50%' }}>Amount ({selectedCard?.c_currencyCode})</div>
							</li>
							{selectedCard?.c_subscriptionAmount?.map((el, i) => (
								<li className='display-flex align-center flex-start'>
									<div style={{ flex: '0 0 50%' }} className='slab-list__title'>
										{textFormatter(el?.type)}
									</div>
									<div style={{ flex: '0 0 50%' }}>
										<Textbox last mb0 borderNone value={el?.amount} disabled={dockerState === 'view'} placeholder='Enter' onBlur={e => handleAmountBlur(e, i)} onChange={e => handleAmount(e, i)} />
									</div>
								</li>
							))}
						</ul>
					</ContentWrapper>
					<BottomSection handleButtonClick={setSavePopupState} disableSave={dockerState === 'view'} />
				</>
			) : (
				<>
					<h3>Client list</h3>
					{cardsDisplay}
					{dockerContainer}
				</>
			)}
		</>
	);
};

export default SlabMaintenance;
